import { Product } from '../types';

// ============================================
// SPECIAL UNIVERSAL CONNECTORS - 2 POLE (EXTENDED)
// ============================================

// 2 POLE SPECIAL CONNECTORS (Additional Variants - Part 3)
export const specialConnector2PoleExtendedProducts: Product[] = [
  {
    id: "special-conn-al-2p-f-4mm-1",
    name: "Ashok Leyland 2 Pole Female - 4mm Wire",
    slug: "special-al-2-pole-female-4mm-1",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Ashok Leyland 2 pole female connector with 4mm deluxe wire.",
    partNumber: "SH2100251",
    image: "/products/special-universal-connectors/special-universal/SH2100251.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "ashok-leyland", "female"],
    applications: ["Ashok Leyland"],
  },
  {
    id: "special-conn-universal-tata-2p-f-4mm-2",
    name: "Universal Tata 2 Pole Female - 4mm Wire (Type 2)",
    slug: "special-universal-tata-2-pole-female-4mm-2",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Universal Tata 2 pole female connector with 4mm deluxe wire.",
    partNumber: "SH2100252",
    image: "/products/special-universal-connectors/special-universal/SH2100252.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "Universal Tata",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "universal", "tata", "female"],
    applications: ["Tata Vehicles"],
  },
  {
    id: "special-conn-universal-tata-fusebox-2p-f-6mm",
    name: "Universal Tata Fuse Box 2 Pole Female - 6mm Wire",
    slug: "special-universal-tata-fusebox-2-pole-female-6mm",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Universal Tata fuse box 2 pole female connector with 6mm deluxe wire.",
    partNumber: "SH2100253",
    image: "/products/special-universal-connectors/special-universal/SH2100253.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "Universal Tata Fuse Box",
      "Wire Type": "6mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "tata", "fuse-box", "female"],
    applications: ["Tata Fuse Box"],
  },
  {
    id: "special-conn-universal-tata-ecm-2p-f-1",
    name: "Universal Tata ECM 2 Pole Female - Special Wire",
    slug: "special-universal-tata-ecm-2-pole-female-1",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Universal Tata ECM 2 pole female connector with ECM special wire.",
    partNumber: "SH2100254",
    image: "/products/special-universal-connectors/special-universal/SH2100254.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "Universal Tata ECM",
      "Wire Type": "ECM Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "tata", "ecm", "female"],
    applications: ["Tata ECM", "Engine Control"],
  },
  {
    id: "special-conn-toyota-qualis-corner-2p-f",
    name: "Toyota Qualis Corner Light 2 Pole Female",
    slug: "special-toyota-qualis-corner-light-2-pole-female",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Toyota Qualis corner light 2 pole female connector with special wire.",
    partNumber: "SH2100255",
    image: "/products/special-universal-connectors/special-universal/SH2100255.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "Toyota Qualis Corner Light",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "toyota", "qualis", "corner-light", "female"],
    applications: ["Toyota Qualis", "Corner Light"],
  },
  {
    id: "special-conn-maximo-2p-f-ecm",
    name: "Mahindra Maximo 2 Pole Female - ECM Wire",
    slug: "special-maximo-2-pole-female-ecm",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Mahindra Maximo 2 pole female connector with special wire.",
    partNumber: "SH2100256",
    image: "/products/special-universal-connectors/special-universal/SH2100256.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "Mahindra Maximo",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "maximo", "female"],
    applications: ["Mahindra Maximo"],
  },
  {
    id: "special-conn-universal-tata-ecm-2p-f-2",
    name: "Universal Tata ECM 2 Pole Female - Type 2",
    slug: "special-universal-tata-ecm-2-pole-female-2",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Universal Tata ECM 2 pole female connector with ECM special wire.",
    partNumber: "SH2100257",
    image: "/products/special-universal-connectors/special-universal/SH2100257.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "Universal Tata ECM",
      "Wire Type": "ECM Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "tata", "ecm", "female"],
    applications: ["Tata ECM"],
  },
  {
    id: "special-conn-high-pressure-switch-2p-f",
    name: "High Pressure Switch 2 Pole Female",
    slug: "special-high-pressure-switch-2-pole-female",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "High pressure switch 2 pole female connector with special wire.",
    partNumber: "SH2100258",
    image: "/products/special-universal-connectors/special-universal/SH2100258.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "High Pressure Switch",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "high-pressure-switch", "female"],
    applications: ["AC High Pressure Switch"],
  },
  {
    id: "special-conn-outside-air-temp-maruti-2p-f",
    name: "Outside Air Temperature Maruti Swift 2 Pole Female",
    slug: "special-outside-air-temp-maruti-swift-2-pole-female",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Outside air temperature sensor for Maruti Swift 2 pole female connector with special wire.",
    partNumber: "SH2100259",
    image: "/products/special-universal-connectors/special-universal/SH2100259.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "Maruti Swift Outside Air Temperature",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "maruti", "swift", "temperature-sensor", "female"],
    applications: ["Maruti Swift", "Temperature Sensor"],
  },
  {
    id: "special-conn-tata-airbag-2p-f",
    name: "Tata Air Bag 2 Pole Female",
    slug: "special-tata-airbag-2-pole-female",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Tata air bag 2 pole female connector with special wire.",
    partNumber: "SH2100260",
    image: "/products/special-universal-connectors/special-universal/SH2100260.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "Tata Air Bag",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "tata", "airbag", "female"],
    applications: ["Tata Air Bag", "Safety Systems"],
  },
  {
    id: "special-conn-maruti-injector-2p-f-special",
    name: "Maruti Injector 2 Pole Female",
    slug: "special-maruti-injector-2-pole-female-special",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Maruti injector 2 pole female connector with special wire.",
    partNumber: "SH2100261",
    image: "/products/special-universal-connectors/special-universal/SH2100261.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "Maruti Injector",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "maruti", "injector", "female"],
    applications: ["Maruti Injector", "Fuel Injection"],
  },
  {
    id: "special-conn-universal-tata-2p-f-special-2",
    name: "Universal Tata 2 Pole Female - Special Wire (Type 2)",
    slug: "special-universal-tata-2-pole-female-special-2",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Universal Tata 2 pole female connector with special wire.",
    partNumber: "SH2100262",
    image: "/products/special-universal-connectors/special-universal/SH2100262.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "Universal Tata",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "universal", "tata", "female"],
    applications: ["Tata Vehicles"],
  },
  {
    id: "special-conn-thermoswitch-zen-2p-f",
    name: "Thermo Switch Zen 2 Pole Female",
    slug: "special-thermoswitch-zen-2-pole-female",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Thermo switch for Zen 2 pole female connector with special wire.",
    partNumber: "SH2100263",
    image: "/products/special-universal-connectors/special-universal/SH2100263.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "Zen Thermo Switch",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "zen", "thermoswitch", "female"],
    applications: ["Maruti Zen", "Thermo Switch"],
  },
  {
    id: "special-conn-al-2p-f-special",
    name: "Ashok Leyland 2 Pole Female - Special Wire",
    slug: "special-al-2-pole-female-special",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Ashok Leyland 2 pole female connector with special wire.",
    partNumber: "SH2100264",
    image: "/products/special-universal-connectors/special-universal/SH2100264.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "ashok-leyland", "female"],
    applications: ["Ashok Leyland"],
  },
  {
    id: "special-conn-ignition-coil-swaraj-2p-f",
    name: "Ignition Coil Swaraj Mazda 2 Pole Female",
    slug: "special-ignition-coil-swaraj-mazda-2-pole-female",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Ignition coil for Swaraj Mazda 2 pole female connector with special wire.",
    partNumber: "SH2100265",
    image: "/products/special-universal-connectors/special-universal/SH2100265.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "Swaraj Mazda Ignition Coil",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "swaraj-mazda", "ignition-coil", "female"],
    applications: ["Swaraj Mazda", "Ignition Coil"],
  },
  {
    id: "special-conn-tata-fuse-universal-2p-f-6mm",
    name: "Tata Fuse Universal 2 Pole Female - 6mm Wire",
    slug: "special-tata-fuse-universal-2-pole-female-6mm",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Tata fuse universal 2 pole female connector with 6mm deluxe wire.",
    partNumber: "SH2100266",
    image: "/products/special-universal-connectors/special-universal/SH2100266.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "Universal Tata Fuse",
      "Wire Type": "6mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "tata", "fuse", "female"],
    applications: ["Tata Fuse"],
  },
  {
    id: "special-conn-universal-tata-2p-f-special-3",
    name: "Universal Tata 2 Pole Female - Special Wire (Type 3)",
    slug: "special-universal-tata-2-pole-female-special-3",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Universal Tata 2 pole female connector with special wire.",
    partNumber: "SH2100267",
    image: "/products/special-universal-connectors/special-universal/SH2100267.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "Universal Tata",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "universal", "tata", "female"],
    applications: ["Tata Vehicles"],
  },
  {
    id: "special-conn-universal-tata-fuse-2p-f-8mm",
    name: "Universal Tata Fuse 2 Pole Female - 8mm Wire",
    slug: "special-universal-tata-fuse-2-pole-female-8mm",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Universal Tata fuse 2 pole female connector with 8mm deluxe wire.",
    partNumber: "SH2100268",
    image: "/products/special-universal-connectors/special-universal/SH2100268.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "Universal Tata Fuse",
      "Wire Type": "8mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "tata", "fuse", "female"],
    applications: ["Tata Fuse"],
  },
  {
    id: "special-conn-universal-2p-f-special-1",
    name: "Universal 2 Pole Female - Special Wire",
    slug: "special-universal-2-pole-female-special-1",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Universal 2 pole female connector with special wire.",
    partNumber: "SH2100269",
    image: "/products/special-universal-connectors/special-universal/SH2100269.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "universal", "female"],
    applications: ["Universal Applications"],
  },
  {
    id: "special-conn-universal-2p-f-special-2",
    name: "Universal 2 Pole Female - Special Wire (Type 2)",
    slug: "special-universal-2-pole-female-special-2",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Universal 2 pole female connector with special wire.",
    partNumber: "SH2100270",
    image: "/products/special-universal-connectors/special-universal/SH2100270.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "universal", "female"],
    applications: ["Universal Applications"],
  },
  {
    id: "special-conn-universal-tata-2p-f-special-4",
    name: "Universal Tata 2 Pole Female - Special Wire (Type 4)",
    slug: "special-universal-tata-2-pole-female-special-4",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Universal Tata 2 pole female connector with special wire.",
    partNumber: "SH2100271",
    image: "/products/special-universal-connectors/special-universal/SH2100271.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "Universal Tata",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "universal", "tata", "female"],
    applications: ["Tata Vehicles"],
  },
  {
    id: "special-conn-universal-2p-f-6mm-40a",
    name: "Universal 2 Pole Female - 6mm Wire & 40A Fuse",
    slug: "special-universal-2-pole-female-6mm-40a-fuse",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Universal 2 pole female connector with 6mm deluxe wire and 40 AMPS fuse.",
    partNumber: "SH2100273",
    image: "/products/special-universal-connectors/special-universal/SH2100273.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Wire Type": "6mm Deluxe",
      "Fuse": "40 AMPS",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "universal", "fuse", "female"],
    applications: ["Universal Applications", "Fuse Connection"],
  },
  {
    id: "special-conn-universal-2p-f-8mm-60a",
    name: "Universal 2 Pole Female - 8mm Wire & 60A Fuse",
    slug: "special-universal-2-pole-female-8mm-60a-fuse",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Universal 2 pole female connector with 8mm deluxe wire and 60 AMPS fuse.",
    partNumber: "SH2100274",
    image: "/products/special-universal-connectors/special-universal/SH2100274.jpg",
    featured: true,
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Wire Type": "8mm Deluxe",
      "Fuse": "60 AMPS",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "universal", "fuse", "female"],
    applications: ["Universal Applications", "Fuse Connection"],
  },
  {
    id: "special-conn-universal-2p-f-special-3",
    name: "Universal 2 Pole Female - Special Wire (Type 3)",
    slug: "special-universal-2-pole-female-special-3",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Universal 2 pole female connector with special wire.",
    partNumber: "SH2100280",
    image: "/products/special-universal-connectors/special-universal/SH2100280.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "universal", "female"],
    applications: ["Universal Applications"],
  },
];

// 2 POLE SPECIAL CONNECTORS (Final Set - Part 4)
export const specialConnector2PoleFinalProducts: Product[] = [
  {
    id: "special-conn-universal-2p-f-ecm-1",
    name: "Universal 2 Pole Female - ECM Special Wire",
    slug: "special-universal-2-pole-female-ecm-1",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Universal 2 pole female connector with ECM special wire.",
    partNumber: "SH2100284",
    image: "/products/special-universal-connectors/special-universal/SH2100284.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Wire Type": "ECM Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "universal", "ecm", "female"],
    applications: ["Universal ECM", "Engine Control"],
  },
  {
    id: "special-conn-universal-2p-f-ecm-2",
    name: "Universal 2 Pole Female - ECM Wire (Type 2)",
    slug: "special-universal-2-pole-female-ecm-2",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Universal 2 pole female connector with ECM wire.",
    partNumber: "SH2100285",
    image: "/products/special-universal-connectors/special-universal/SH2100285.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Wire Type": "ECM Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "universal", "ecm", "female"],
    applications: ["Universal ECM"],
  },
  {
    id: "special-conn-universal-2p-f-6mm",
    name: "Universal 2 Pole Female - 6mm Deluxe Wire",
    slug: "special-universal-2-pole-female-6mm",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Universal 2 pole female connector with 6mm deluxe wire.",
    partNumber: "SH2100286",
    image: "/products/special-universal-connectors/special-universal/SH2100286.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Wire Type": "6mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "universal", "female"],
    applications: ["Universal Applications"],
  },
  {
    id: "special-conn-universal-2p-f-ecm-3",
    name: "Universal 2 Pole Female - ECM Special Wire (Type 3)",
    slug: "special-universal-2-pole-female-ecm-3",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Universal 2 pole female connector with ECM special wire.",
    partNumber: "SH2100287",
    image: "/products/special-universal-connectors/special-universal/SH2100287.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Wire Type": "ECM Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "universal", "ecm", "female"],
    applications: ["Universal ECM"],
  },
  {
    id: "special-conn-universal-2p-f-ecm-4",
    name: "Universal 2 Pole Female - ECM Special Wire (Type 4)",
    slug: "special-universal-2-pole-female-ecm-4",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Universal 2 pole female connector with ECM special wire.",
    partNumber: "SH2100288",
    image: "/products/special-universal-connectors/special-universal/SH2100288.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Wire Type": "ECM Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "universal", "ecm", "female"],
    applications: ["Universal ECM"],
  },
  {
    id: "special-conn-universal-2p-f-special-4",
    name: "Universal 2 Pole Female - Special Wire (Type 4)",
    slug: "special-universal-2-pole-female-special-4",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Universal 2 pole female connector with special wire.",
    partNumber: "SH2100289",
    image: "/products/special-universal-connectors/special-universal/SH2100289.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "universal", "female"],
    applications: ["Universal Applications"],
  },
  {
    id: "special-conn-universal-2p-f-special-5",
    name: "Universal 2 Pole Female - Special Wire (Type 5)",
    slug: "special-universal-2-pole-female-special-5",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Universal 2 pole female connector with special wire.",
    partNumber: "SH2100290",
    image: "/products/special-universal-connectors/special-universal/SH2100290.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "universal", "female"],
    applications: ["Universal Applications"],
  },
  {
    id: "special-conn-indica-diesel-fuse-2p-f",
    name: "Indica Diesel Fuse 2 Pole Female - 8mm Wire",
    slug: "special-indica-diesel-fuse-2-pole-female-8mm",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Indica Diesel fuse 2 pole female connector with 8mm deluxe wire.",
    partNumber: "SH2100292",
    image: "/products/special-universal-connectors/special-universal/SH2100292.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "Indica Diesel Fuse",
      "Wire Type": "8mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "indica", "diesel", "fuse", "female"],
    applications: ["Tata Indica Diesel", "Fuse"],
  },
  {
    id: "special-conn-universal-2p-f-special-6",
    name: "Universal 2 Pole Female - Special Wire (Type 6)",
    slug: "special-universal-2-pole-female-special-6",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Universal 2 pole female connector with special wire.",
    partNumber: "SH2100294",
    image: "/products/special-universal-connectors/special-universal/SH2100294.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "universal", "female"],
    applications: ["Universal Applications"],
  },
  {
    id: "special-conn-universal-tata-2p-f-4mm-3",
    name: "Universal Tata 2 Pole Female - 4mm Wire (Type 3)",
    slug: "special-universal-tata-2-pole-female-4mm-3",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Universal Tata 2 pole female connector with 4mm deluxe wire.",
    partNumber: "SH2100295",
    image: "/products/special-universal-connectors/special-universal/SH2100295.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "Universal Tata",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "universal", "tata", "female"],
    applications: ["Tata Vehicles"],
  },
  {
    id: "special-conn-universal-2p-f-special-7",
    name: "Universal 2 Pole Female - Special Wire (Type 7)",
    slug: "special-universal-2-pole-female-special-7",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Universal 2 pole female connector with special wire.",
    partNumber: "SH2100296",
    image: "/products/special-universal-connectors/special-universal/SH2100296.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "universal", "female"],
    applications: ["Universal Applications"],
  },
  {
    id: "special-conn-universal-tata-tail-light-2p-f",
    name: "Universal Tata Tail Light Holder 2 Pole Female",
    slug: "special-universal-tata-tail-light-2-pole-female",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Universal Tata tail light holder 2 pole female connector with ECM special wire.",
    partNumber: "SH2100297",
    image: "/products/special-universal-connectors/special-universal/SH2100297.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "Universal Tata Tail Light",
      "Wire Type": "ECM Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "tata", "tail-light", "female"],
    applications: ["Tata Tail Light"],
  },
  {
    id: "special-conn-universal-al-2p-f-special",
    name: "Universal Ashok Leyland 2 Pole Female - Special Wire",
    slug: "special-universal-al-2-pole-female-special",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Universal Ashok Leyland 2 pole female connector with special wire.",
    partNumber: "SH2100298",
    image: "/products/special-universal-connectors/special-universal/SH2100298.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "Universal Ashok Leyland",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "ashok-leyland", "female"],
    applications: ["Ashok Leyland"],
  },
  {
    id: "special-conn-universal-2p-f-ecm-5",
    name: "Universal 2 Pole Female - ECM Special Wire (Type 5)",
    slug: "special-universal-2-pole-female-ecm-5",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Universal 2 pole female connector with ECM special wire.",
    partNumber: "SH2100299",
    image: "/products/special-universal-connectors/special-universal/SH2100299.png",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Wire Type": "ECM Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "universal", "ecm", "female"],
    applications: ["Universal ECM"],
  },
];
